import { mountLanding } from './pages/landing.js';
import { mountFirehose } from './pages/firehose.js';
import { mountFrequencies } from './pages/frequencies.js';
import { mountFrequency } from './pages/frequency.js';
import { mountFaq } from './pages/faq.js';
import { mountDocs } from './pages/docs.js';
import { mountDocDetail } from './pages/docs-detail.js';
import { startRouter, isRoute, parseFrequencyRoute, parseInnerAnchor, parseDocRoute } from './router.js';
import { loadKeysFromLocation } from './key-handoff.js';

const appRoot = document.getElementById('app');
if (appRoot === null) {
  throw new Error('missing #app root');
}
const app: HTMLElement = appRoot;

let cleanup: (() => void) | null = null;

function navigate(hash: string): void {
  if (cleanup !== null) {
    cleanup();
    cleanup = null;
  }
  if (isRoute(hash, '#/firehose')) {
    cleanup = mountFirehose(app);
    return;
  }
  if (isRoute(hash, '#/frequencies')) {
    cleanup = mountFrequencies(app);
    return;
  }
  if (isRoute(hash, '#/faq')) {
    cleanup = mountFaq(app, parseInnerAnchor(hash));
    return;
  }
  const docSlug = parseDocRoute(hash);
  if (docSlug !== null) {
    if (docSlug === '') {
      cleanup = mountDocs(app);
    } else {
      cleanup = mountDocDetail(app, docSlug, parseInnerAnchor(hash));
    }
    return;
  }
  const freqMatch = parseFrequencyRoute(hash);
  if (freqMatch !== null) {
    cleanup = mountFrequency(app, freqMatch);
    return;
  }
  cleanup = mountLanding(app);
}

// Parse handoff fragment (if any) before initial navigation. After
// loadKeysFromLocation runs, the URL is rewritten to #/frequencies so the
// router naturally takes us to the frequencies view.
void loadKeysFromLocation()
  .catch(() => null)
  .finally(() => {
    startRouter({ onRouteChange: navigate });
  });
